<div *ngIf="observationDetails" class="flex flex-col w-full print:hidden">
  <div class="flex flex-col sm:flex-row items-stretch my-3 gap-3">
    <div class="w-full border flex items-center darken-bg rounded-lg overflow-hidden relative">
      <span
        *ngIf="isAiObservation && !observationDetails?.screen_shot"
        class="ppe-ai-screenshot-missing absolute bottom-0 left-0 right-0 text-center px-2 py-1 text-xs bg-black bg-opacity-60 text-white"
        >{{ 'ppe.ai.screenshot_missing' | transloco }}</span
      >
      <img
        *ngIf="
          observationDetails?.screen_shot &&
          observationDetails.unique_id !== 'WH-8170' &&
          observationDetails.unique_id !== 'WH-9810' &&
          observationDetails.unique_id !== 'WH-5271'
        "
        [src]="observationDetails?.screen_shot"
        (error)="onImageError($event)"
        class="w-full"
      />
      <img
        *ngIf="
          !observationDetails?.screen_shot &&
          observationDetails.unique_id !== 'WH-8170' &&
          observationDetails.unique_id !== 'WH-9810' &&
          observationDetails.unique_id !== 'WH-5271'
        "
        class="w-full"
        [src]="noImagePlaceholderPath"
      />
      <img
        *ngIf="observationDetails.unique_id === 'WH-8170'"
        src="assets/krpano/media/noHelmet.png"
        class="w-full"
      />
      <img
        *ngIf="observationDetails.unique_id === 'WH-9810'"
        src="assets/krpano/media/poorHouse.png"
        class="w-full"
      />
      <img
        *ngIf="observationDetails.unique_id === 'WH-5271'"
        src="assets/krpano/media/crack.png"
        class="w-full"
      />
    </div>
    <div class="w-full md:w-5/12 px-5 border rounded-md flex flex-col">
      <div class="pt-2 flex flex-col">
        <label>{{ 'Observation ID' | transloco }} </label>
        <div class="break-words" style="max-width: 100%">
          #{{ observationDetails?.unique_id | uppercase }}
        </div>
      </div>
      <div *ngIf="isAiObservation" class="ppe-ai-details flex flex-col mt-2">
        <div *ngIf="aiConfidencePercent !== null" class="ppe-ai-confidence flex flex-col mt-2">
          <label>{{ 'ppe.ai.confidence' | transloco }}</label>
          <div>
            {{ 'ppe.ai.confidence_value' | transloco: { confidence: aiConfidencePercent } }}
          </div>
        </div>
        <app-ppe-ai-report-action
          class="flex mt-2 mb-2"
          [observation]="observationDetails"
        ></app-ppe-ai-report-action>
      </div>
      <div *ngIf="shouldShowUnifierLink()" class="flex flex-col mt-2">
        <label>{{ 'unifier_observation_link' | transloco }}</label>
        <div class="break-words" style="max-width: 100%">
          <a
            *ngIf="observationDetails?.unifier_observation_link"
            (click)="openUnifierLink(observationDetails.unifier_observation_link)"
            class="cursor-pointer flex items-center gap-2 text-primary hover:text-primary-600"
            [attr.href]="observationDetails.unifier_observation_link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span class="underline">{{ 'unifier_observation_link' | transloco }}</span>
            <mat-icon class="icon-size-4" svgIcon="open_in_new"></mat-icon>
          </a>
          <span *ngIf="!observationDetails?.unifier_observation_link">N/A</span>
        </div>
      </div>
      <div *ngIf="shouldShowRecordNo()" class="flex flex-col mt-2">
        <label>{{ 'record_no' | transloco }}</label>
        <div class="break-words" style="max-width: 100%">
          {{
            observationDetails?.unifier_observation_id
              ? (observationDetails?.unifier_observation_id | uppercase)
              : '-'
          }}
        </div>
      </div>
      <div *ngIf="shouldShowSequenceNo()" class="flex flex-col mt-2">
        <label>{{ (observationDetails?.type_label || 'Sequence') + ' No.' }}</label>
        <div class="break-words" style="max-width: 100%">
          {{
            observationDetails?.unifier_sequence_number
              ? (observationDetails?.unifier_sequence_number | uppercase)
              : '-'
          }}
        </div>
      </div>
      <div *ngIf="shouldShowTotalRecordRev()" class="flex flex-col mt-2">
        <label>{{
          (shouldShowFullRecordRevLabel() ? 'Total Record Rev#' : 'Rev#') | transloco
        }}</label>
        <div class="break-words" style="max-width: 100%">
          {{
            observationDetails?.unifier_total_record_revisions !== null &&
            observationDetails?.unifier_total_record_revisions !== undefined
              ? toInteger(observationDetails?.unifier_total_record_revisions)
              : '-'
          }}
        </div>
      </div>
      <!-- sync status -->
      <div *ngIf="shouldShowSyncStatus()" class="flex flex-col mt-2">
        <label>{{ 'Sync Status' | transloco }}</label>
        <div class="break-words" style="max-width: 100%">
          <ng-container *ngIf="observationDetails?.unifier_sync_out_results; else noSyncStatus">
            <div class="flex items-center mt-1">
              <ng-container [ngSwitch]="observationDetails.unifier_sync_out_results?.status">
                <span
                  *ngSwitchCase="'not-synced'"
                  class="px-2 py-1 rounded text-xs font-medium bg-red-100 text-red-800"
                >
                  {{ 'NOT-SYNCED' | uppercase }}
                </span>
                <span
                  *ngSwitchCase="'sync-updates-failed'"
                  class="px-2 py-1 rounded text-xs font-medium bg-red-100 text-red-800"
                >
                  {{ 'SYNC-UPDATES-FAILED' | uppercase }}
                </span>
                <span
                  *ngSwitchCase="'success'"
                  class="px-2 py-1 rounded text-xs font-medium bg-white text-gray-900 border border-gray-300"
                >
                  {{ 'SUCCESS' | uppercase }}
                </span>
                <span
                  *ngSwitchDefault
                  class="px-2 py-1 rounded text-xs font-medium bg-gray-300 text-gray-600"
                >
                  {{ observationDetails.unifier_sync_out_results?.status || 'queued' | uppercase }}
                </span>
              </ng-container>
              <span
                *ngIf="observationDetails.unifier_sync_out_results?.status_description"
                class="ml-2 text-sm text-gray-600"
                [matTooltip]="observationDetails.unifier_sync_out_results.status_description"
              >
                <mat-icon class="icon-size-4" svgIcon="info"></mat-icon>
              </span>
            </div>
          </ng-container>
          <ng-template #noSyncStatus>
            <div class="flex items-center mt-1">
              <span class="px-2 py-1 rounded text-xs font-medium bg-gray-300 text-gray-600">
                {{ 'QUEUED' | transloco }}
              </span>
            </div>
          </ng-template>
        </div>
      </div>
      <div *ngIf="shouldShowRelatedLogsButton()" class="flex flex-col mt-2">
        <label>{{ 'Related MIR/WIR Logs' | transloco }}</label>
        <div class="break-words" style="max-width: 100%">
          <div
            (click)="openRelatedLogsDialog()"
            class="cursor-pointer flex items-center mt-1"
            style="width: fit-content"
          >
            <mat-icon
              [matTooltip]="
                (observationDetails.logs_button?.logs_count ?? 0) === 0
                  ? ('No logs available' | transloco)
                  : ('View related logs' | transloco)
              "
              class="icon-size-4 mr-2"
              [class.opacity-30]="(observationDetails.logs_button?.logs_count ?? 0) === 0"
              svgIcon="open_in_new"
            ></mat-icon>
            <span>{{ observationDetails.logs_button?.logs_count ?? 0 }}</span>
            &nbsp;
            <span>
              {{
                observationDetails.logs_button?.label
                  ? (observationDetails.logs_button.label | transloco)
                  : ('Logs' | transloco)
              }}
            </span>
          </div>
        </div>
      </div>
      <div class="flex flex-col mt-2">
        <label>{{ 'created_at' | transloco }}</label>
        <div [innerHTML]="observationDetails?.created_at | dateTransform"></div>
      </div>
      <div class="pt-2 pb-3">
        <label>{{ 'created_by' | transloco }}: </label>
        <div
          *ngIf="
            observationDetails.unique_id !== 'WH-8170' &&
            observationDetails.unique_id !== 'WH-9810' &&
            observationDetails.unique_id !== 'WH-5271' &&
            observationDetails.title !== 'NOT WEARING SAFETY HELMET' &&
            observationDetails.title !== 'NOT WEARING SAFETY VEST'
          "
        >
          <!-- A system creator (the PPE AI author) keeps its exact name and has no account status. -->
          {{
            observationDetails?.creator?.is_system
              ? observationDetails?.creator?.name
              : (observationDetails?.creator?.name | titlecase)
          }}
          <span
            *ngIf="
              !observationDetails?.creator?.is_system &&
              observationDetails?.creator?.status !== 'Active'
            "
            class="text-white rounded-lg shadow px-2 ms-1 max-h-6 items-center"
            [ngClass]="{
              'bg-gray-500': observationDetails?.creator?.status === 'Inactive',
              'bg-green-500': observationDetails?.creator?.status === 'Active',
              'bg-orange-500': observationDetails?.creator?.status === 'Deactivated',
              'bg-red-500': observationDetails?.creator?.status === 'Expired'
            }"
            >({{ observationDetails?.creator?.status | transloco }})</span
          >
        </div>
        <div
          *ngIf="
            observationDetails.unique_id === 'WH-8170' ||
            observationDetails.unique_id === 'WH-9810' ||
            observationDetails.unique_id === 'WH-5271' ||
            observationDetails.title === 'NOT WEARING SAFETY HELMET' ||
            observationDetails.title === 'NOT WEARING SAFETY VEST'
          "
        >
          {{ 'WhiteHelmet AI' | transloco }}
        </div>
      </div>
      <mat-divider class="my-2"></mat-divider>
      <div class="mt-2 flex flex-col" *ngIf="!changeTitle">
        <div class="flex flex-row w-full items-center">
          <h3 class="break-words flex-grow" style="max-width: 100%">
            <label>{{ 'title' | transloco }}: </label>
          </h3>
          <div class="ml-2">
            <button
              [disabled]="
                !getUpdatePermission() ||
                isEditing ||
                isLoading ||
                isLoadingCustomFields ||
                isFieldNonEditable('title')
              "
              (click)="changeTitle = true; editModeEmitter.emit(true); focusTitle(); startEditing()"
              [matTooltip]="
                isFieldNonEditable('title')
                  ? ('This field is linked to a parent record and cannot be edited' | transloco)
                  : null
              "
            >
              <mat-icon color="primary" class="icon-3" svgIcon="edit"></mat-icon>
            </button>
          </div>
        </div>
        <div class="flex flex-row flex-wrap items-center gap-2">
          <span class="break-words">{{ observationDetails?.title }}</span>
          <span
            *ngIf="isAiObservation"
            class="ppe-ai-detected-badge inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold whitespace-nowrap bg-orange-100 text-orange-700 dark:bg-orange-900 dark:text-orange-200"
            data-testid="ppe-ai-detected-badge"
            >{{ 'ppe.ai.detected' | transloco }}</span
          >
        </div>
      </div>
      <div class="mt-2" *ngIf="changeTitle">
        <div class="flex flex-row w-full items-center">
          <div class="flex flex-grow flex-col">
            <label>{{ 'title' | transloco }}: </label>
            <input
              #titleValue
              [value]="observationDetails.title"
              class="text-white"
              [maxlength]="titleMaxLength"
            />
          </div>
          <div class="flex flex-row gap-2">
            <button (click)="changeTitle = false; stopEditing()">
              <mat-icon svgIcon="close" class="icon-size-5"></mat-icon>
            </button>

            <button>
              <mat-icon
                color="primary"
                class="cursor-pinter icon-size-5"
                svgIcon="check"
                (click)="editObservationTitle(titleValue.value); stopEditing()"
              ></mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div class="mt-2 flex flex-col" *ngIf="!changeSignificance && isFieldVisible('significance')">
        <div class="flex flex-row w-full items-center">
          <label class="flex flex-grow items-center">
            <h3>{{ 'significance' | transloco }}:</h3>
          </label>
          <button
            class="justify-center"
            [disabled]="
              !getUpdatePermission() ||
              isEditing ||
              isLoading ||
              isLoadingCustomFields ||
              isFieldNonEditable('significance')
            "
            (click)="changeSignificance = true; editModeEmitter.emit(true); startEditing()"
            [matTooltip]="
              isFieldNonEditable('significance')
                ? ('This field is linked to a parent record and cannot be edited' | transloco)
                : null
            "
          >
            <mat-icon color="primary" class="icon-3" svgIcon="edit"></mat-icon>
          </button>
        </div>
        <div
          class="w-max rounded-lg shadow px-2 ms-1 max-h-6 items-center text-white"
          [ngClass]="{
            inProgress: observationDetails?.significance === 'low',
            pending: observationDetails?.significance === 'medium',
            'bg-warn-500': observationDetails?.significance === 'high',
            'bg-gray-500': observationDetails?.significance === 'none',
            closed: observationDetails?.significance === 'opportunity_for_improvement',
            completed: observationDetails?.significance === 'good_practice'
          }"
        >
          {{ observationDetails?.significance_label }}
        </div>
        <div class="mt-2 w-full" *ngIf="!changePrivacy && isFieldVisible('privacy')">
          <div class="flex flex-row items-center">
            <label class="flex flex-grow">{{ 'privacy' | transloco }}: </label>
            <button
              class="justify-center"
              [disabled]="
                !getUpdatePermission() ||
                isEditing ||
                isLoading ||
                isLoadingCustomFields ||
                isFieldNonEditable('privacy')
              "
              (click)="changePrivacy = true; editModeEmitter.emit(true); startEditing()"
              [matTooltip]="
                isFieldNonEditable('privacy')
                  ? ('This field is linked to a parent record and cannot be edited' | transloco)
                  : null
              "
            >
              <mat-icon color="primary" class="icon-3" svgIcon="edit"></mat-icon>
            </button>
          </div>
          <div class="flex flex-row w-full items-center">
            <div class="flex flex-grow">
              {{ observationDetails?.privacy | transloco | titlecase }}
            </div>
          </div>
        </div>
        <!-- drop down for significance-->

        <!-- drop down for Privacy-->

        <div class="flex flex-col w-full my-4" *ngIf="changePrivacy && isFieldVisible('privacy')">
          <div class="flex flex-row w-full items-center">
            <mat-form-field
              [class]="'w-full me-3 mat-dense ' + (isArabic() ? 'text-left' : 'text-right')"
              color="primary"
              appearance="outline"
              [dir]="isArabic() ? 'rtl' : 'ltr'"
            >
              <mat-label>{{ 'privacy' | transloco }}</mat-label>
              <mat-select #privacyVal [value]="observationDetails?.privacy">
                <mat-option *ngFor="let privacy of observationPrivacy" [value]="privacy">
                  {{ privacy | transloco }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div class="flex flex-row items-center gap-2">
              <button (click)="changePrivacy = false; stopEditing()">
                <mat-icon class="icon-5" svgIcon="close"></mat-icon>
              </button>

              <button>
                <mat-icon
                  color="primary"
                  class="icon-5"
                  svgIcon="check"
                  (click)="editObservationPrivacy(privacyVal.value); stopEditing()"
                ></mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="flex flex-col w-full my-4"
        *ngIf="changeSignificance && isFieldVisible('significance')"
      >
        <div class="flex flex-row w-full items-center">
          <mat-form-field
            [class]="'w-full me-3 mat-dense ' + (isArabic() ? 'text-left' : 'text-right')"
            color="primary"
            appearance="outline"
            [dir]="isArabic() ? 'rtl' : 'ltr'"
          >
            <mat-label>{{ 'significance' | transloco }}</mat-label>
            <mat-select #significanceVal [value]="observationDetails?.significance">
              <mat-option
                *ngFor="let significance of observationSignificances"
                [value]="significance.value"
              >
                {{ significance.label | removeUnderscore | titlecase | transloco }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="flex flex-row items-center gap-2">
            <button (click)="changeSignificance = false; stopEditing()">
              <mat-icon class="icon-5" svgIcon="close"></mat-icon>
            </button>

            <button>
              <mat-icon
                color="primary"
                class="icon-5"
                svgIcon="check"
                (click)="editObservationSignificance(significanceVal.value); stopEditing()"
              ></mat-icon>
            </button>
          </div>
        </div>
      </div>

      <!--      label for status-->
      <div *ngIf="observationDetails?.type !== 'note'" class="mt-2">
        <div *ngIf="!changeStatus" class="flex flex-col">
          <div
            *ngIf="
              observationDetails.unique_id !== 'WH-8170' &&
              observationDetails.unique_id !== 'WH-9810' &&
              observationDetails.unique_id !== 'WH-5271'
            "
          >
            <div class="flex flex-row w-full items-center">
              <label class="flex flex-grow">{{ 'status' | transloco }}: </label>
              <button
                [disabled]="
                  (!observationDetails.permissions?.includes(
                    ObservationPermissions.CHANGE_OBSERVATION_STATUS
                  ) &&
                    !observationDetails.permissions?.includes(
                      ObservationPermissions.CAN_CLOSE_OBSERVATION
                    )) ||
                  isClosedAndLocked ||
                  isEditing ||
                  observationDetails.is_draft ||
                  isLoading ||
                  isLoadingCustomFields ||
                  isStatusEditingDisabledForNWC() ||
                  isFieldNonEditable('status')
                "
                (click)="changeStatus = true; editModeEmitter.emit(true); startEditing()"
                [matTooltip]="
                  isFieldNonEditable('status')
                    ? ('This field is linked to a parent record and cannot be edited' | transloco)
                    : isStatusEditingDisabledForNWC()
                    ? ('Status editing is not allowed for this observation type' | transloco)
                    : null
                "
              >
                <mat-icon color="primary" mat-list-icon class="icon-3" svgIcon="edit"></mat-icon>
              </button>
            </div>
            <div class="flex flex-row items-center gap-2">
              <div
                class="w-max rounded-lg shadow px-2 ms-1 max-h-6 items-center text-white"
                [ngClass]="getStatusClass(observationDetails.is_draft, validatedStatus)"
              >
                {{
                  (observationDetails?.is_draft ? 'Draft' : validatedStatus)?.replace('_', ' ')
                    | transloco
                    | titlecase
                }}
              </div>
              <mat-icon
                *ngIf="isClosedAndLocked"
                svgIcon="heroicons_solid:lock-closed"
                class="text-gray-400 w-4 h-4"
                [matTooltip]="'OBSERVATION_LOCKED_CLOSED' | transloco"
              >
              </mat-icon>
            </div>
          </div>
        </div>
        <!-- drop down for status-->
        <div class="flex flex-col w-full my-4" *ngIf="changeStatus">
          <div class="flex flex-row w-full items-center">
            <mat-form-field
              [class]="'w-full me-3 mat-dense ' + (isArabic() ? 'text-left' : 'text-right')"
              appearance="outline"
              [dir]="isArabic() ? 'rtl' : 'ltr'"
            >
              <mat-label>{{ 'status' | transloco }}</mat-label>
              <mat-select #statusVal [value]="validatedStatus">
                <mat-option
                  *ngFor="let status of observationStatus"
                  [value]="status.value"
                  [disabled]="status.disabled"
                >
                  {{ status?.name | titlecase | transloco }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div class="flex flex-row items-center gap-2">
              <button (click)="changeStatus = false; stopEditing()">
                <mat-icon class="icon-5" svgIcon="close"></mat-icon>
              </button>

              <button>
                <mat-icon
                  color="primary"
                  class="icon-5"
                  svgIcon="check"
                  (click)="editObservationStatus(statusVal.value); stopEditing()"
                ></mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!--      label for Type   -->
      <div *ngIf="observationDetails?.type && isFieldVisible('type')" class="mt-2">
        <div *ngIf="!changeType" class="flex flex-col">
          <div
            *ngIf="
              observationDetails.unique_id !== 'WH-8170' &&
              observationDetails.unique_id !== 'WH-9810' &&
              observationDetails.unique_id !== 'WH-5271'
            "
          >
            <div class="flex flex-row w-full items-center">
              <label class="flex flex-grow">{{ 'type' | transloco }}: </label>
              <button
                data-testid="edit-type-button"
                [disabled]="
                  !getUpdatePermission() ||
                  isEditing ||
                  observationDetails?.type === 'note' ||
                  isLoading ||
                  isLoadingCustomFields ||
                  isTypeDropdownDisabled() ||
                  isTypeEditingDisabledForNWC() ||
                  isFieldNonEditable('type')
                "
                (click)="changeType = true; editModeEmitter.emit(true); startEditing()"
                [matTooltip]="
                  isFieldNonEditable('type')
                    ? ('This field is linked to a parent record and cannot be edited' | transloco)
                    : observationDetails?.type === 'note'
                    ? noteTypeMessage
                    : isTypeDropdownDisabled()
                    ? ('This observation type cannot be changed' | transloco)
                    : isTypeEditingDisabledForNWC()
                    ? ('Type editing is disabled for NWC clients' | transloco)
                    : null
                "
              >
                <mat-icon color="primary" mat-list-icon svgIcon="edit" class="icon-3"></mat-icon>
              </button>
            </div>
            <div class="w-max rounded-lg shadow px-2 ms-1 max-h-6 items-center text-white inactive">
              {{
                observationDetails?.type_label === 'SAR'
                  ? ('observationType.SAR' | transloco)
                  : observationDetails?.type_label
              }}
            </div>
          </div>
        </div>
        <!-- drop down for status-->
        <div class="flex flex-col w-full my-4" *ngIf="changeType">
          <div class="flex flex-row w-full items-center">
            <mat-form-field
              [class]="'w-full me-3 mat-dense ' + (isArabic() ? 'text-left' : 'text-right')"
              appearance="outline"
              [dir]="isArabic() ? 'rtl' : 'ltr'"
            >
              <mat-label>{{ 'type' | transloco }}</mat-label>
              <mat-select
                #typeVal
                [value]="observationDetails?.type"
                data-testid="edit-type-select"
              >
                <ng-container *ngFor="let type of observationTypes">
                  <mat-option
                    *ngIf="type.value !== 'note'"
                    [value]="type.value"
                    [disabled]="isObservationTypeDisabled(type.value)"
                  >
                    {{ type.label }}
                  </mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>
            <div class="flex flex-row items-center gap-2">
              <button (click)="changeType = false; stopEditing()">
                <mat-icon class="icon-5" svgIcon="close"></mat-icon>
              </button>

              <button data-testid="edit-type-save">
                <mat-icon
                  color="primary"
                  class="icon-5"
                  svgIcon="check"
                  (click)="editObservationType(typeVal.value); stopEditing()"
                ></mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!--      label for code   -->
      <div *ngIf="observationDetails?.code && isFieldVisible('code')" class="mt-2">
        <div *ngIf="!changeCode" class="flex flex-col">
          <div>
            <div class="flex flex-row w-full items-center">
              <label class="flex flex-grow">{{ 'Code' | transloco }}: </label>
              <button
                (click)="changeCode = true; editModeEmitter.emit(true); startEditing()"
                [disabled]="
                  !getUpdateCodePermission() ||
                  isEditing ||
                  isLoading ||
                  isLoadingCustomFields ||
                  isFieldNonEditable('code')
                "
                [matTooltip]="
                  isFieldNonEditable('code')
                    ? ('This field is linked to a parent record and cannot be edited' | transloco)
                    : null
                "
              >
                <mat-icon color="primary" mat-list-icon class="icon-3" svgIcon="edit"></mat-icon>
              </button>
            </div>
            <div class="flex flex-grow">
              {{ observationDetails?.code_info }}
            </div>
          </div>
        </div>
        <!-- drop down for change code-->
        <div class="flex flex-col w-full my-4" *ngIf="changeCode">
          <div class="flex flex-row w-full items-center">
            <mat-form-field
              [class]="'w-full me-3 mat-dense ' + (isArabic() ? 'text-left' : 'text-right')"
              appearance="outline"
              [dir]="isArabic() ? 'rtl' : 'ltr'"
            >
              <mat-label>{{ 'Code' | transloco }}</mat-label>
              <mat-select #codeVal>
                <mat-option *ngFor="let code of observationCodes; index as i" [value]="code.value">
                  {{ code.label }}
                  <span class="ms-2 text-secondary">
                    {{ code?.description ? '(' + code.description + ')' : '' }}
                  </span>
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div class="flex flex-row items-center gap-2">
              <button (click)="changeCode = false; stopEditing()">
                <mat-icon class="icon-5" svgIcon="close"></mat-icon>
              </button>

              <button>
                <mat-icon
                  color="primary"
                  class="icon-5"
                  svgIcon="check"
                  (click)="editObservationCode(codeVal.value)"
                ></mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>

      <mat-divider class="my-2"></mat-divider>

      <!--      label for due date-->
      <div
        *ngIf="
          observationDetails?.type !== 'note' &&
          observationDetails.unique_id !== 'WH-8170' &&
          observationDetails.unique_id !== 'WH-9810' &&
          observationDetails.unique_id !== 'WH-5271' &&
          isFieldVisible('due_date')
        "
      >
        <div *ngIf="!changeDueDate">
          <div
            class="flex flex-col"
            *ngIf="
              observationDetails.unique_id !== 'WH-8170' &&
              observationDetails.unique_id !== 'WH-9810' &&
              observationDetails.unique_id !== 'WH-5271'
            "
          >
            <div class="flex flex-row w-full items-center">
              <label class="flex flex-grow">{{ 'Due Date' | transloco }} </label>
              <button
                [disabled]="
                  !getUpdatePermission() ||
                  isEditing ||
                  isLoading ||
                  isLoadingCustomFields ||
                  isFieldNonEditable('due_date')
                "
                (click)="changeDueDate = true; editModeEmitter.emit(true); startEditing()"
                [matTooltip]="
                  isFieldNonEditable('due_date')
                    ? ('This field is linked to a parent record and cannot be edited' | transloco)
                    : null
                "
              >
                <mat-icon color="primary" class="icon-3" svgIcon="edit"></mat-icon>
              </button>
            </div>
          </div>
          <div [innerHTML]="observationDetails?.due_date | dateTransform"></div>
        </div>
      </div>
      <!--      dropdown for due date-->
      <div
        class="flex flex-row items-center my-4"
        *ngIf="changeDueDate && isFieldVisible('due_date')"
      >
        <div class="w-full">
          <mat-form-field
            appearance="outline"
            [dir]="translateService.getActiveLang() === 'ar' ? 'rtl' : 'ltr'"
            class="w-full mat-dense"
          >
            <mat-label class="text-primary">{{ 'Due Date' | transloco }}</mat-label>
            <input
              (dateChange)="getDate($event.value)"
              [formControl]="currentDueDate"
              [min]="minDate"
              [ngxMatDatetimePicker]="picker"
              matInput
              [placeholder]="'Choose a date' | transloco"
            />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <ngx-mat-datetime-picker #picker></ngx-mat-datetime-picker>
          </mat-form-field>
        </div>

        <div class="flex flex-row items-center gap-2 ms-3">
          <button (click)="changeDueDate = false; stopEditing()">
            <mat-icon class="icon-5" svgIcon="close"></mat-icon>
          </button>

          <button [disabled]="confirmButton">
            <mat-icon
              [color]="'primary'"
              class="icon-5"
              svgIcon="check"
              (click)="editObservationDueDate(); stopEditing()"
            ></mat-icon>
          </button>
        </div>
      </div>
      <!--      Floor name -->
      <div>
        <div>
          <div class="flex flex-col">
            <div class="flex flex-row w-full items-center">
              <label class="flex flex-grow">{{ 'Floor Name' | transloco }} </label>
              <button [disabled]="true">
                <mat-icon color="primary" class="icon-3" svgIcon="edit"></mat-icon>
              </button>
            </div>
          </div>
          <div>
            {{ observationDetails?.floor?.floor_name || 'N/A' | transloco }}
          </div>
        </div>
      </div>

      <div
        class="flex flex-col pt-2 pb-3"
        *ngIf="observationDetails.observation_flag !== 'observation_on_document'"
      >
        <label class="flex flex-row mb-2 color">{{ 'Location' | transloco }}: </label>
        <div style="position: relative">
          <img
            [src]="observationDetails.floor?.floor_image"
            class="rounded-md overflow-hidden"
            style="max-width: 100%; max-height: 100%"
            (load)="adjustDotPosition($event)"
          />
          <div
            class="dot"
            style="position: absolute"
            [style.left]="(getX(observationDetails) / imageNaturalWidth) * 100 + '%'"
            [style.top]="(getY(observationDetails) / imageNaturalHeight) * 100 + '%'"
          >
            <div
              style="
                background-color: yellow;
                border: 1px solid black;
                width: 10px;
                height: 10px;
                border-radius: 50%;
              "
            ></div>
          </div>
          <div
            class="flex flex-row items-center rounded-md overflow-hidden opacity-90"
            style="
              background-image: linear-gradient(-90deg, var(--fuse-accent-900), transparent);
              right: 0px;
              bottom: 0px;
              height: 114px;
              position: absolute;
              width: 70%;
              height: 35px;
              overflow: hidden;
            "
            [ngClass]="
              translateService.getActiveLang() === 'en' ? 'justify-end pe-3' : 'justify-start ps-3'
            "
          >
            <!--            <span-->
            <!--              [matTooltip]="observationDetails?.floor?.floor_name | titlecase"-->
            <!--              class="font-bold"-->
            <!--              style="color: var(&#45;&#45;fuse-primary-500)"-->
            <!--              >{{ observationDetails?.floor?.floor_name | titlecase }}</span-->
            <!--            >-->
            <!--            <span *ngIf="observationDetails.point.point_name !== null" class="px-2">|</span>-->
            <span
              [matTooltip]="'Point Name' | transloco"
              *ngIf="observationDetails.point?.point_name !== null"
              >{{ observationDetails?.point?.point_name | titlecase }}</span
            >
          </div>
        </div>
      </div>

      <div
        *ngIf="observationDetails?.type !== 'note'"
        class="flex flex-row items-center justify-between mt-4"
      >
        <label class="flex flex-row color">{{ 'Close-Out Evidence' | transloco }}: </label>
        <div class="flex flex-row items-center gap-2">
          <button
            (click)="changeEvidenceAttachment = true; editModeEmitter.emit(true); startEditing()"
            [disabled]="
              !observationDetails.permissions?.includes(AccessLevel.UPLOAD_OBSERVATION_EVIDENCE) ||
              isEditing ||
              isLoading ||
              isLoadingCustomFields ||
              isFieldNonEditable('evidence_file')
            "
            [matTooltip]="
              isFieldNonEditable('evidence_file')
                ? ('This field is linked to a parent record and cannot be edited' | transloco)
                : null
            "
          >
            <mat-icon color="primary" class="icon-3" svgIcon="edit"></mat-icon>
          </button>
          <button
            *ngIf="changeEvidenceAttachment"
            (click)="changeEvidenceAttachment = false; stopEditing()"
          >
            <mat-icon class="icon-5" svgIcon="close"></mat-icon>
          </button>
        </div>
      </div>

      <div
        class="text-secondary"
        *ngIf="!observationDetails?.evidence_file && observationDetails?.type !== 'note'"
      >
        {{ 'No Evidence Attached' | transloco }}
      </div>

      <app-file-uploader
        class="mt-2"
        *ngIf="changeEvidenceAttachment"
        [title]="'Click here to upload evidence (e.g Image, video or file)' | transloco"
        [multiple]="false"
        [fileType]="'file'"
        (filesList)="evidenceAttachment = $event"
        [options]="fileOptions"
        [uploadAction]="true"
        (uploadActionClicked)="doUpload()"
      ></app-file-uploader>

      <div *ngIf="observationDetails?.evidence_file" class="flex flex-col w-full">
        <span class="text-secondary"> </span>
        <div class="max-w-32 my-2 p-4 justify-center darker-bg rounded-md flex flex-wrap gap-5">
          <button
            (click)="
              openPreviewer(
                observationDetails?.evidence_file,
                getFileExtension(observationDetails?.evidence_file),
                getFileName(observationDetails?.evidence_file)
              )
            "
            [matTooltip]="
              observationDetails?.evidence_file.substring(
                observationDetails?.evidence_file.lastIndexOf('/') + 1
              ) | titlecase
            "
            class="relative hover:opacity-70 transition-all h-20 bg-accent-800 flex justify-center rounded-md"
            style="min-width: 6.5rem"
          >
            <ng-container [ngSwitch]="observationDetails?.evidence_file_type">
              <ng-container *ngSwitchCase="'image'">
                <img
                  class="h-15 w-auto rounded-md"
                  [src]="observationDetails.evidence_file"
                  [height]="27.75"
                  [width]="30"
                  alt="Evidence Attachment"
                />
                <mat-icon
                  class="absolute z-20 top-1 right-1 icon-size-4"
                  [ngClass]="{
                    'text-white': !changeEvidenceAttachment,
                    'text-warn': changeEvidenceAttachment
                  }"
                  [svgIcon]="
                    changeEvidenceAttachment ? 'heroicons_solid:trash' : 'mat_solid:download'
                  "
                  (click)="
                    evidenceAction(observationDetails?.evidence_file); $event.stopPropagation()
                  "
                  style="cursor: pointer"
                >
                </mat-icon>

                <div
                  class="absolute w-full h-full z-10 rounded-lg overflow-hidden bg-accent-900 opacity-30"
                ></div>
              </ng-container>

              <ng-container *ngSwitchCase="'video'">
                <div class="flex h-15 w-auto rounded-md items-center">
                  <mat-icon svgIcon="ondemand_video"></mat-icon>
                  <mat-icon
                    class="absolute z-20 top-1 right-1 icon-size-4"
                    [ngClass]="{
                      'text-white': !changeEvidenceAttachment,
                      'text-warn': changeEvidenceAttachment
                    }"
                    [svgIcon]="
                      changeEvidenceAttachment ? 'heroicons_solid:trash' : 'mat_solid:download'
                    "
                    (click)="
                      evidenceAction(observationDetails?.evidence_file); $event.stopPropagation()
                    "
                    style="cursor: pointer"
                  >
                  </mat-icon>
                </div>
              </ng-container>

              <ng-container *ngSwitchDefault>
                <div class="flex h-15 w-auto rounded-md items-center">
                  <mat-icon svgIcon="document_scanner"></mat-icon>
                  <mat-icon
                    class="absolute z-20 top-1 right-1 icon-size-4"
                    [ngClass]="{
                      'text-white': !changeEvidenceAttachment,
                      'text-warn': changeEvidenceAttachment
                    }"
                    [svgIcon]="
                      changeEvidenceAttachment ? 'heroicons_solid:trash' : 'mat_solid:download'
                    "
                    (click)="
                      evidenceAction(observationDetails?.evidence_file); $event.stopPropagation()
                    "
                    style="cursor: pointer"
                  >
                  </mat-icon>
                </div>
              </ng-container>
            </ng-container>

            <div
              class="absolute top-15 px-2 text-secondary text-sm flex-row w-full whitespace-nowrap"
            >
              {{
                observationDetails?.evidence_file.substring(
                  observationDetails?.evidence_file.lastIndexOf('/') + 1
                )
                  | titlecase
                  | truncate: 15 : translateService.getActiveLang()
              }}
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- full sized inputs -->
  <div>
    <div class="flex sm:flex-row flex-col justify-start gap-4">
      <div class="sm:w-1/2 w-full mt-2 border p-2 rounded-lg">
        <div *ngIf="!changeCategories">
          <div class="flex justify-between items-center">
            <div class="flex flex-row items-center w-full">
              <label class="flex flex-grow">{{ 'categories' | transloco }}</label>

              <div>
                <button
                  (click)="changeCategories = true; editModeEmitter.emit(true); startEditing()"
                  [disabled]="
                    !getUpdatePermission() ||
                    isEditing ||
                    isLoading ||
                    isLoadingCustomFields ||
                    isFieldNonEditable('categories')
                  "
                  [matTooltip]="
                    isFieldNonEditable('categories')
                      ? ('This field is linked to a parent record and cannot be edited' | transloco)
                      : null
                  "
                >
                  <mat-icon color="primary" class="icon-3" svgIcon="edit"></mat-icon>
                </button>
              </div>
            </div>
          </div>

          <div class="p-2">
            <!-- Show all categories for Non-NWC clients, first category only for NWC clients -->
            <ng-container *ngIf="!nwc_client && observationDetails?.categories?.length">
              <span *ngFor="let category of observationDetails?.categories" class="pill">
                {{ getCategoryDisplayName(category) }}
              </span>
            </ng-container>
            <!-- NWC clients: show only first category from categories_str -->
            <span *ngIf="nwc_client && observationDetails?.categories_str" class="pill">
              {{ observationDetails?.categories_str?.split(',')[0] }}
            </span>
          </div>

          <!-- Sub-categories display -->
          <div *ngIf="observationDetails?.sub_categories?.length" class="mt-2">
            <div class="flex flex-row items-center w-full">
              <label class="flex flex-grow text-sm text-secondary">{{
                'sub-categories' | transloco
              }}</label>
            </div>

            <div class="p-2">
              <span
                *ngFor="let subCategory of observationDetails?.sub_categories"
                class="pill text-sm"
              >
                {{ getCategoryDisplayName(subCategory) }}
              </span>
            </div>
          </div>
        </div>

        <div *ngIf="changeCategories" class="flex flex-col my-4 mt-2">
          <div class="flex-grow mb-3">
            <mat-form-field
              appearance="outline"
              [class]="
                'flex-grow mat-dense -mb-4 w-full ' + (isArabic() ? 'text-left' : 'text-right')
              "
              [dir]="isArabic() ? 'rtl' : 'ltr'"
            >
              <mat-label>{{ 'categories' | transloco }}</mat-label>
              <mat-select
                #categoriesVal
                [(ngModel)]="selectedCategories"
                (selectionChange)="onCategorySelectionChange()"
                [multiple]="!nwc_client"
              >
                <mat-option *ngFor="let item of categories" [value]="item?.id">
                  {{ getCategoryDisplayName(item) }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Sub-categories selection -->
          <div class="flex-grow mb-3" *ngIf="observationChildCategories.length > 0">
            <mat-form-field
              appearance="outline"
              [class]="
                'flex-grow mat-dense -mb-4 w-full ' + (isArabic() ? 'text-left' : 'text-right')
              "
              [dir]="isArabic() ? 'rtl' : 'ltr'"
            >
              <mat-label>
                {{ 'sub-categories' | transloco }}
                <span class="text-warn-500 font-bold text-lg ml-1">*</span>
              </mat-label>
              <mat-select
                #childCategoriesVal
                [(ngModel)]="selectedChildCategories"
                [multiple]="!nwc_client"
              >
                <mat-option *ngFor="let item of observationChildCategories" [value]="item?.id">
                  {{ getCategoryDisplayName(item) }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="ms-2 mt-5 flex flex-row gap-2">
            <button (click)="changeCategories = false; stopEditing()">
              <mat-icon class="icon-5" svgIcon="close"></mat-icon>
            </button>

            <button>
              <mat-icon
                class="icon-5"
                color="primary"
                svgIcon="check"
                (click)="
                  editObservationCategories(
                    this.categoriesVal?.value || selectedCategories,
                    this.childCategoriesVal?.value || selectedChildCategories
                  );
                  stopEditing()
                "
              ></mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div class="sm:w-1/2 w-full mt-2 border p-2 rounded-lg">
        <div *ngIf="!changeMembers" class="flex flex-row items-center w-full">
          <div class="w-full">
            <div class="flex flex-row w-full items-center">
              <label class="flex flex-grow">{{ 'Assignees' | transloco }}</label>
              <button
                (click)="changeMembers = true; editModeEmitter.emit(true); startEditing()"
                [disabled]="
                  !getUpdatePermission() ||
                  isEditing ||
                  isLoading ||
                  isLoadingCustomFields ||
                  isFieldNonEditable('user_assignees')
                "
                [matTooltip]="
                  isFieldNonEditable('user_assignees')
                    ? ('This field is linked to a parent record and cannot be edited' | transloco)
                    : null
                "
              >
                <mat-icon color="primary" class="icon-3" svgIcon="edit"></mat-icon>
              </button>
            </div>
            <div *ngIf="!observationDetails?.user_assignees?.length" class="text-secondary">
              {{ 'No Users Assigned' | transloco }}
            </div>
            <div class="p-2" *ngIf="observationDetails?.user_assignees?.length">
              <span
                class="rounded-lg shadow px-2 max-h-8 text-white bg-accent-500"
                [ngClass]="{
                  'bg-gray-500': member?.includes('Inactive') || member?.includes('غير نشط'),
                  'bg-green-500': member?.includes('Active') || member?.includes('نشط'),
                  'bg-orange-500': member?.includes('Deactivated') || member?.includes('غير مفعل'),
                  'bg-red-500': member?.includes('Expired') || member?.includes('منتهي الصلاحية')
                }"
                *ngFor="let member of observationDetails?.user_assignees_str?.split(',')"
                class="pill"
              >
                {{ member | titlecase }}
              </span>
            </div>
          </div>
          <div></div>
        </div>

        <div *ngIf="changeMembers" class="flex justify-between items-center">
          <div class="flex-grow">
            <mat-form-field
              appearance="outline"
              [class]="
                'flex-grow mat-dense my-4 -mb-4 w-full ' + (isArabic() ? 'text-left' : 'text-right')
              "
              [dir]="isArabic() ? 'rtl' : 'ltr'"
            >
              <mat-label>{{ 'members' | transloco }}</mat-label>
              <mat-select [(ngModel)]="selectedObservationMembers" multiple>
                <!-- Search input for selecting users -->
                <mat-option>
                  <ngx-mat-select-search
                    #singleSelect
                    [formControl]="searchControl"
                    [noEntriesFoundLabel]="'No result found' | transloco"
                    [placeholderLabel]="'Search' | transloco"
                  ></ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let member of filteredUsers" [value]="member.uuid">
                  {{ member?.name | titlecase }}
                  <span class="text-secondary">({{ member?.email }})</span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="ms-2 mt-5 flex flex-row gap-2">
            <button (click)="changeMembers = false; stopEditing()">
              <mat-icon class="icon-5" svgIcon="close"></mat-icon>
            </button>
            <button>
              <mat-icon
                class="icon-5"
                color="primary"
                svgIcon="check"
                (click)="doChangeMembers(); stopEditing()"
              ></mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full mt-2 border p-2 rounded-lg">
      <div *ngIf="!changeHashtags">
        <div class="flex flex-row items-center w-full">
          <label class="flex flex-grow">{{ 'Hashtags' | transloco }}</label>
          <button
            type="button"
            (click)="startChangeHashtags()"
            [disabled]="!getUpdatePermission() || isEditing || isLoading || isLoadingCustomFields"
          >
            <mat-icon color="primary" class="icon-3" svgIcon="edit"></mat-icon>
          </button>
        </div>
        <div class="p-2" *ngIf="getDisplayHashtags().length === 0">
          <span class="text-secondary">{{ 'No Hashtags Added' | transloco }}</span>
        </div>
        <div class="p-2" *ngIf="getDisplayHashtags().length > 0">
          <span *ngFor="let tag of getDisplayHashtags()" class="pill">{{ tag }}</span>
        </div>
      </div>

      <div *ngIf="changeHashtags" class="flex flex-col gap-2">
        <app-observation-hashtags
          [projectId]="hashtagsApiProjectId"
          [selectedHashtagsArray]="selectedObservationHashtags"
          [isOptional]="true"
          (hashtagsEmitter)="onObservationHashtagsDraftChange($event)"
        ></app-observation-hashtags>
        <div class="ms-2 mt-2 flex flex-row gap-2">
          <button type="button" (click)="cancelChangeHashtags()">
            <mat-icon class="icon-5" svgIcon="close"></mat-icon>
          </button>
          <button type="button" [disabled]="isSavingHashtags" (click)="saveObservationHashtags()">
            <mat-icon class="icon-5" color="primary" svgIcon="check"></mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="flex sm:flex-row flex-col w-full gap-4 mt-2">
      <div class="sm:w-1/2 w-full max-h-50 overflow-y-auto mt-2 border p-2 rounded-lg">
        <div class="w-full">
          <div class="flex flex-row w-full items-center">
            <div class="flex flex-col w-full">
              <div class="flex flex-row items-center w-full">
                <label class="flex flex-grow">{{ 'description' | transloco }} </label>

                <button
                  class="justify-center"
                  (click)="
                    openDialog('desc');
                    changeDescription = true;
                    editModeEmitter.emit(true);
                    startEditing();
                    focusDescription()
                  "
                  [disabled]="
                    !getUpdatePermission() ||
                    isEditing ||
                    isLoading ||
                    isLoadingCustomFields ||
                    isFieldNonEditable('description')
                  "
                  [matTooltip]="
                    isFieldNonEditable('description')
                      ? ('This field is linked to a parent record and cannot be edited' | transloco)
                      : null
                  "
                >
                  <mat-icon color="primary" class="icon-3" svgIcon="edit"></mat-icon>
                </button>
              </div>
              <div class="w-full">
                <p
                  class="ql-editor break-all max-w-full"
                  style="overflow-wrap: anywhere"
                  [ngClass]="[
                    observationDetails?.description ? '' : 'text-secondary',
                    translateService.getActiveLang() === 'ar' ? 'isRTL' : 'isLTR'
                  ]"
                  [innerHTML]="observationDetails?.description ?? ('No Description' | transloco)"
                ></p>
              </div>
            </div>
          </div>
        </div>
        <!--        edit description-->
        <div class="mt-2">
          <ng-template #dialogTemplateDesc>
            <h2 mat-dialog-title>{{ 'description' | transloco }}</h2>
            <mat-dialog-content>
              <div class="w-full items-center">
                <div class="flex flex-grow flex-col">
                  <quill-editor
                    #descriptionValue
                    [ngModel]="observationDetails.description"
                    [placeholder]="'Write the description' | transloco"
                    [styles]="{ direction: isArabic() ? 'rtl' : 'ltr' }"
                    (onEditorCreated)="onEditorCreated($event, 'description')"
                    [modules]="quillConfig"
                    class="w-full"
                  ></quill-editor>
                  <div
                    class="text-sm text-gray-500 mt-1 text-end"
                    *ngIf="getDescriptionTextLimits() !== null"
                  >
                    {{ getDescriptionCharCount() }}/{{ getDescriptionTextLimits() }}
                    {{ 'characters' | transloco }}
                  </div>
                </div>
                <div class="flex flex-row items-center gap-2"></div>
              </div>
            </mat-dialog-content>

            <mat-dialog-actions>
              <div class="flex justify-end gap-1 w-full">
                <button
                  class="mat-dense"
                  (click)="changeDescription = false; stopEditing(); dialogRef?.close()"
                  mat-raised-button
                >
                  <mat-icon class="icon-5" svgIcon="close"></mat-icon>
                  {{ 'Close' | transloco }}
                </button>

                <button
                  class="mat-dense"
                  mat-raised-button
                  color="primary"
                  (click)="
                    editObservationDescription(descriptionEditor.getText());
                    stopEditing();
                    dialogRef?.close()
                  "
                >
                  <mat-icon class="icon-5" svgIcon="check"></mat-icon>
                  {{ 'Update' | transloco }}
                </button>
              </div>
            </mat-dialog-actions>
          </ng-template>
        </div>
      </div>
      <!--      attachments-->
      <div
        class="sm:w-1/2 w-1/2 mt-2 border max-h-50 overflow-y-auto p-2 rounded-lg"
        *ngIf="
          observationDetails.unique_id !== 'WH-8170' &&
          observationDetails.unique_id !== 'WH-9810' &&
          observationDetails.unique_id !== 'WH-5271'
        "
      >
        <div class="flex flex-row items-center">
          <label class="flex flex-grow">{{ 'attachments' | transloco }}</label>
          <button
            *ngIf="!changeAttachments"
            (click)="changeAttachments = true; editModeEmitter.emit(true); startEditing()"
            [disabled]="
              !getUpdatePermission() ||
              isEditing ||
              isLoading ||
              isLoadingCustomFields ||
              isFieldNonEditable('attached_files')
            "
            [matTooltip]="
              isFieldNonEditable('attached_files')
                ? ('This field is linked to a parent record and cannot be edited' | transloco)
                : null
            "
          >
            <mat-icon color="primary" class="icon-3" svgIcon="edit"></mat-icon>
          </button>
        </div>
        <div class="text-secondary" *ngIf="observationDetails?.attached_files?.length === 0">
          {{ 'No Files Attached' | transloco }}
        </div>
        <app-file-uploader
          *ngIf="changeAttachments"
          [options]="fileOptionsAttachments"
          [multiple]="true"
          (filesList)="attachments = $event"
        >
        </app-file-uploader>
        <div *ngIf="observationDetails?.attached_files?.length > 0" class="flex flex-col w-full">
          <span class="text-secondary"> </span>
          <div
            class="w-full mt-2 py-5 px-2 darker-bg rounded-md flex flex-wrap justify-start gap-5"
          >
            <button
              (click)="openPreviewer(attach.path, attach.extension, attach.file_name)"
              [matTooltip]="attach.file_name"
              class="relative hover:opacity-70 transition-all h-20 bg-accent-800 flex justify-center rounded-md"
              style="min-width: 4.5rem"
              *ngFor="let attach of observationDetails.attached_files"
            >
              <ng-container [ngSwitch]="attach.extension">
                <ng-container *ngSwitchCase="'png'">
                  <img
                    class="h-15 w-auto rounded-md"
                    [src]="attach.path"
                    [alt]="attach.file_name"
                  />
                  <mat-icon
                    *ngIf="!changeAttachments"
                    class="absolute z-20 top-1 right-1 icon-size-4 text-white"
                    (click)="attachmentAction(attach); $event.stopPropagation()"
                    [svgIcon]="'mat_solid:download'"
                  >
                  </mat-icon>
                  <mat-icon
                    *ngIf="changeAttachments"
                    (click)="attachmentAction(attach); $event.stopPropagation()"
                    [svgIcon]="'heroicons_solid:trash'"
                    class="absolute z-20 top-1 right-1 icon-size-4"
                    [ngClass]="{
                      'text-warn': changeAttachments && attach.can_delete,
                      'text-disabled': changeAttachments && !attach.can_delete
                    }"
                    [matTooltipDisabled]="attach.can_delete"
                    matTooltip="{{
                      'You are not authorized to delete this attachment.' | transloco
                    }}"
                  >
                  </mat-icon>

                  <div
                    class="absolute w-full h-full z-10 rounded-lg overflow-hidden bg-accent-900 opacity-30"
                  ></div>
                </ng-container>
                <ng-container *ngSwitchCase="'jpeg'">
                  <img
                    class="h-15 w-auto rounded-md"
                    [src]="attach.path"
                    [alt]="attach.file_name"
                  />
                  <mat-icon
                    class="absolute z-20 top-1 right-1 icon-size-4"
                    [ngClass]="{
                      'text-white': !changeAttachments,
                      'text-warn': changeAttachments && attach.can_delete,
                      'text-disabled': changeAttachments && !attach.can_delete
                    }"
                    (click)="attachmentAction(attach); $event.stopPropagation()"
                    [svgIcon]="changeAttachments ? 'heroicons_solid:trash' : 'mat_solid:download'"
                    [matTooltipDisabled]="attach.can_delete"
                    matTooltip="{{
                      'You are not authorized to delete this attachment.' | transloco
                    }}"
                  >
                  </mat-icon>

                  <div
                    class="absolute w-full h-full z-10 rounded-lg overflow-hidden bg-accent-900 opacity-30"
                  ></div>
                </ng-container>
                <ng-container *ngSwitchCase="'jpg'">
                  <img
                    class="h-15 w-auto rounded-md"
                    [src]="attach.path"
                    [alt]="attach.file_name"
                  />
                  <mat-icon
                    class="absolute z-20 top-1 right-1 icon-size-4"
                    [ngClass]="{
                      'text-white': !changeAttachments,
                      'text-warn': changeAttachments && attach.can_delete,
                      'text-disabled': changeAttachments && !attach.can_delete
                    }"
                    (click)="attachmentAction(attach); $event.stopPropagation()"
                    [svgIcon]="changeAttachments ? 'heroicons_solid:trash' : 'mat_solid:download'"
                    [matTooltipDisabled]="attach.can_delete"
                    matTooltip="{{
                      'You are not authorized to delete this attachment.' | transloco
                    }}"
                  >
                  </mat-icon>

                  <div
                    class="absolute w-full h-full z-10 rounded-lg overflow-hidden bg-accent-900 opacity-30"
                  ></div>
                </ng-container>

                <ng-container *ngSwitchCase="'mp4'">
                  <div class="flex h-15 w-auto rounded-md items-center">
                    <mat-icon svgIcon="ondemand_video"></mat-icon>
                    <mat-icon
                      class="absolute z-20 top-1 right-1 icon-size-4"
                      [ngClass]="{
                        'text-white': !changeAttachments,
                        'text-warn': changeAttachments && attach.can_delete,
                        'text-disabled': changeAttachments && !attach.can_delete
                      }"
                      (click)="attachmentAction(attach); $event.stopPropagation()"
                      [svgIcon]="changeAttachments ? 'heroicons_solid:trash' : 'mat_solid:download'"
                      [matTooltipDisabled]="attach.can_delete"
                      matTooltip="{{
                        'You are not authorized to delete this attachment.' | transloco
                      }}"
                    >
                    </mat-icon>
                  </div>
                </ng-container>

                <ng-container *ngSwitchDefault>
                  <div class="flex h-15 w-auto rounded-md items-center">
                    <mat-icon svgIcon="document_scanner"></mat-icon>
                    <mat-icon
                      class="absolute z-20 top-1 right-1 icon-size-4"
                      [ngClass]="{
                        'text-white': !changeAttachments,
                        'text-warn': changeAttachments && attach.can_delete,
                        'text-disabled': changeAttachments && !attach.can_delete
                      }"
                      (click)="attachmentAction(attach); $event.stopPropagation()"
                      [svgIcon]="changeAttachments ? 'heroicons_solid:trash' : 'mat_solid:download'"
                      [matTooltipDisabled]="attach.can_delete"
                      matTooltip="{{
                        'You are not authorized to delete this attachment.' | transloco
                      }}"
                    >
                    </mat-icon>
                  </div>
                </ng-container>
              </ng-container>

              <div class="absolute top-15 px-2 text-secondary text-sm flex-row w-full">
                {{ attach.file_name | titlecase | truncate: 7 : translateService.getActiveLang() }}
              </div>
            </button>
          </div>
        </div>
        <div *ngIf="changeAttachments" class="ms-2 mt-5 flex flex-row gap-2 justify-end">
          <button (click)="changeAttachments = false; stopEditing()">
            <mat-icon class="icon-5" svgIcon="close"></mat-icon>
          </button>

          <button>
            <mat-icon
              class="icon-5"
              color="primary"
              svgIcon="check"
              (click)="editObservationAttachments(); stopEditing()"
            ></mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="flex sm:flex-row flex-col w-full gap-4 mt-2">
      <div class="sm:w-full w-full max-h-50 overflow-y-auto mt-2 border p-2 rounded-lg">
        <div class="w-full">
          <div class="flex flex-row w-full items-center">
            <div class="flex flex-grow flex-col">
              <div class="flex flex-row items-center w-full">
                <label class="flex flex-grow"
                  >{{ 'recommended corrective action' | transloco }}
                </label>

                <button
                  class="justify-center"
                  (click)="
                    openDialog('recommended');
                    changeRecommendedAction = true;
                    editModeEmitter.emit(true);
                    startEditing();
                    focusRecommendedAction()
                  "
                  [disabled]="
                    !getUpdatePermission() ||
                    isEditing ||
                    isLoading ||
                    isLoadingCustomFields ||
                    isFieldNonEditable('recommended_corrective_action')
                  "
                  [matTooltip]="
                    isFieldNonEditable('recommended_corrective_action')
                      ? ('This field is linked to a parent record and cannot be edited' | transloco)
                      : null
                  "
                >
                  <mat-icon color="primary" class="icon-3" svgIcon="edit"></mat-icon>
                </button>
              </div>

              <div class="w-full">
                <p
                  class="ql-editor break-all max-w-full"
                  style="overflow-wrap: anywhere"
                  [ngClass]="[
                    observationDetails?.recommended_corrective_action ? '' : 'text-secondary',
                    translateService.getActiveLang() === 'ar' ? 'isRTL' : 'isLTR'
                  ]"
                  [innerHTML]="
                    observationDetails?.recommended_corrective_action ??
                    ('No Recommended Corrective Action' | transloco)
                  "
                ></p>
              </div>
            </div>
          </div>
        </div>
        <!--        edit Recommended Action-->
        <div class="mt-2">
          <ng-template #dialogTemplateRecc>
            <h2 mat-dialog-title>{{ 'recommended corrective action' | transloco }}</h2>

            <mat-dialog-content>
              <div class="w-full items-center">
                <div class="flex flex-grow flex-col">
                  <quill-editor
                    #recommendedActionValue
                    [ngModel]="observationDetails.recommended_corrective_action"
                    [placeholder]="'Write the recommended corrective action' | transloco"
                    [styles]="{ direction: isArabic() ? 'rtl' : 'ltr' }"
                    (onEditorCreated)="onEditorCreated($event, 'recommendedAction')"
                    [modules]="quillConfig"
                    class="w-full"
                  ></quill-editor>
                  <div
                    class="text-sm text-gray-500 mt-1 text-end"
                    *ngIf="getRecommendedActionTextLimits() !== null"
                  >
                    {{ getRecommendedActionCharCount() }}/{{ getRecommendedActionTextLimits() }}
                    {{ 'characters' | transloco }}
                  </div>
                </div>
                <div class="flex flex-row items-center gap-2"></div>
              </div>
            </mat-dialog-content>
            <mat-dialog-actions>
              <div class="flex justify-end gap-1 w-full">
                <button
                  class="mat-dense"
                  (click)="changeRecommendedAction = false; stopEditing(); dialogRef?.close()"
                  mat-raised-button
                >
                  <mat-icon class="icon-5" svgIcon="close"></mat-icon>
                  {{ 'Close' | transloco }}
                </button>

                <button
                  class="mat-dense"
                  mat-raised-button
                  color="primary"
                  (click)="
                    editObservationRecommendedAction(recommendedActionEditor.getText());
                    stopEditing();
                    dialogRef?.close()
                  "
                >
                  <mat-icon class="icon-5" svgIcon="check"></mat-icon>
                  {{ 'Update' | transloco }}
                </button>
              </div>
            </mat-dialog-actions>
          </ng-template>
        </div>
      </div>
    </div>

    <!--      Custom Fields -->
    <!-- Loading skeleton for custom fields -->
    <div *ngIf="isLoadingCustomFields" class="grid sm:grid-cols-2 grid-cols-1 gap-4 mt-2">
      <div
        *ngFor="let i of [1, 2, 3, 4]"
        class="w-full mt-2 border p-2 rounded-lg min-w-0 animate-pulse"
      >
        <div class="flex flex-row w-full items-center mb-3">
          <div class="h-4 bg-gray-500 rounded w-1/3"></div>
          <div class="ml-auto h-6 w-6 bg-gray-500 rounded"></div>
        </div>
        <div class="h-10 bg-gray-400 rounded w-full"></div>
      </div>
    </div>

    <div
      *ngIf="!isLoadingCustomFields && customFields && customFields.length > 0"
      class="grid sm:grid-cols-2 grid-cols-1 gap-4 mt-2"
    >
      <!-- Only render fields that should be visible (dependency satisfied and not child fields) -->
      <ng-container *ngFor="let field of visibleCustomFields; trackBy: trackByField">
        <div class="w-full mt-2 border p-2 rounded-lg min-w-0">
          <!-- Read-only mode -->
          <div *ngIf="!isFieldEditing(field.name)" class="flex flex-col w-full">
            <div class="flex flex-row w-full items-center">
              <label class="flex flex-grow">{{ field.label }}</label>
              <div
                [matTooltip]="
                  field.read_only
                    ? ('This field is read-only' | transloco)
                    : isFieldNonEditable(field.name)
                    ? ('This field is linked to a parent record and cannot be edited' | transloco)
                    : null
                "
                [matTooltipDisabled]="!field.read_only && !isFieldNonEditable(field.name)"
              >
                <button
                  type="button"
                  (click)="startEditingField(field.name)"
                  [disabled]="
                    !getUpdatePermission() ||
                    isEditing ||
                    isLoading ||
                    isLoadingCustomFields ||
                    field.read_only ||
                    isFieldNonEditable(field.name)
                  "
                >
                  <mat-icon color="primary" class="icon-3" svgIcon="edit"></mat-icon>
                </button>
              </div>
            </div>

            <div class="p-2">
              <app-editable-custom-field-renderer
                [field]="field"
                [form]="customFieldsForm"
                [isEditing]="false"
                (onEditCustomField)="onEditCustomField($event)"
              ></app-editable-custom-field-renderer>
            </div>

            <!-- Nested Child Field (Read-only) -->
            <div
              *ngIf="hasVisibleChildField(field)"
              class="mt-2 ml-4 pl-4 border-l-2 border-gray-200"
            >
              <ng-container *ngIf="getChildFieldForParent(field) as childField">
                <div class="flex flex-col w-full">
                  <label class="flex flex-grow mb-2">{{ childField.label }}</label>
                  <div class="p-2">
                    <app-editable-custom-field-renderer
                      [field]="childField"
                      [form]="customFieldsForm"
                      [isEditing]="false"
                      (onEditCustomField)="onEditCustomField($event)"
                    ></app-editable-custom-field-renderer>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>

          <!-- Edit mode for individual field -->
          <div *ngIf="isFieldEditing(field.name)" class="flex flex-col w-full">
            <app-editable-custom-field-renderer
              [field]="field"
              [form]="customFieldsForm"
              [isEditing]="true"
              [loadingState]="isLoadingCustomFields"
              (onEditCustomField)="onEditCustomField($event)"
            ></app-editable-custom-field-renderer>

            <!-- Nested Child Field (Edit mode) -->
            <div
              *ngIf="hasVisibleChildField(field)"
              class="mt-2 ml-4 pl-4 border-l-2 border-gray-200"
            >
              <ng-container *ngIf="getChildFieldForParent(field) as childField">
                <app-editable-custom-field-renderer
                  [field]="childField"
                  [form]="customFieldsForm"
                  [isEditing]="true"
                  [loadingState]="isLoadingCustomFields"
                  (onEditCustomField)="onEditCustomField($event)"
                ></app-editable-custom-field-renderer>
              </ng-container>
            </div>

            <!-- Save/Cancel buttons for individual field -->
            <div class="flex flex-row items-center gap-2 mt-2">
              <button (click)="cancelCustomField(field.name)">
                <mat-icon class="icon-5" svgIcon="close"></mat-icon>
              </button>

              <button
                (click)="saveCustomField(field.name)"
                [disabled]="!isCustomFieldValid(field.name)"
                [ngClass]="{
                  'opacity-50 cursor-not-allowed': !isCustomFieldValid(field.name),
                  'cursor-pointer': isCustomFieldValid(field.name)
                }"
                [matTooltip]="
                  !isCustomFieldValid(field.name) ? getCustomFieldErrorMessage(field.name) : ''
                "
                matTooltipPosition="above"
              >
                <mat-icon
                  [color]="isCustomFieldValid(field.name) ? 'primary' : 'disabled'"
                  class="icon-5"
                  svgIcon="check"
                ></mat-icon>
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<!--For Print Only -   -->
<div class="flex-col hidden forPrint print:block text-3xl print-area" *ngIf="observationDetails">
  <div class="flex flex-row items-stretch my-3 max gap-3">
    <div
      class="w-full sm:w-7/12 border print-area flex items-center justify-center darken-bg rounded-lg"
    >
      <img
        *ngIf="
          observationDetails.unique_id !== 'WH-8170' &&
          observationDetails.unique_id !== 'WH-9810' &&
          observationDetails.unique_id !== 'WH-5271'
        "
        class="max-h-[43rem] w-auto"
        [src]="observationDetails?.screen_shot"
        (error)="onImageError($event)"
      />
      <img
        *ngIf="observationDetails.unique_id === 'WH-8170'"
        src="assets/krpano/media/noHelmet.png"
        class="w-full"
      />
      <img
        *ngIf="observationDetails.unique_id === 'WH-9810'"
        src="assets/krpano/media/poorHouse.png"
        class="w-full"
      />
      <img
        *ngIf="observationDetails.unique_id === 'WH-5271'"
        src="assets/krpano/media/crack.png"
        class="w-full"
      />
    </div>
    <div class="w-5/12 px-5 border flex flex-col">
      <div class="mt-2">
        <label>{{ 'title' | transloco }}: </label>
        <h3 class="text-lg font-semibold break-words">
          {{ observationDetails?.title }}
        </h3>
      </div>
      <div *ngIf="shouldShowUnifierLink()" class="mt-2">
        <label>{{ 'unifier_observation_link' | transloco }}: </label>
        <div>
          <a
            *ngIf="observationDetails?.unifier_observation_link"
            [attr.href]="observationDetails.unifier_observation_link"
            target="_blank"
            rel="noopener noreferrer"
            class="text-primary"
          >
            {{ 'unifier_observation_link' | transloco }}
          </a>
          <span *ngIf="!observationDetails?.unifier_observation_link">N/A</span>
        </div>
      </div>
      <div *ngIf="shouldShowRecordNo()" class="mt-2">
        <label>{{ 'record_no' | transloco }}: </label>
        <div>
          {{
            observationDetails?.unifier_observation_id
              ? (observationDetails?.unifier_observation_id | uppercase)
              : '-'
          }}
        </div>
      </div>
      <div *ngIf="shouldShowSequenceNo()" class="mt-2">
        <label>{{ (observationDetails?.type_label || 'Sequence') + ' No.' }}: </label>
        <div>
          {{
            observationDetails?.unifier_sequence_number
              ? (observationDetails?.unifier_sequence_number | uppercase)
              : '-'
          }}
        </div>
      </div>
      <div *ngIf="shouldShowTotalRecordRev()" class="mt-2">
        <label
          >{{ (shouldShowFullRecordRevLabel() ? 'Total Record Rev#' : 'Rev#') | transloco }}:
        </label>
        <div>
          {{
            observationDetails?.unifier_total_record_revisions !== null &&
            observationDetails?.unifier_total_record_revisions !== undefined
              ? toInteger(observationDetails?.unifier_total_record_revisions)
              : '-'
          }}
        </div>
      </div>
      <div class="mt-2">
        <label>{{ 'created_at' | transloco }}: </label>
        <div [innerHTML]="observationDetails?.created_at | dateTransform"></div>
      </div>
      <div class="flex flex-row justify-between">
        <div class="mt-2 w-full">
          <label>{{ 'significance' | transloco }}: </label>
          <div>{{ observationDetails?.significance_label | titlecase }}</div>
        </div>
      </div>

      <div class="pt-2 pb-3">
        <label>{{ 'created_by' | transloco }}: </label>
        <div
          *ngIf="
            observationDetails.unique_id !== 'WH-8170' &&
            observationDetails.unique_id !== 'WH-9810' &&
            observationDetails.unique_id !== 'WH-5271'
          "
        >
          {{
            observationDetails?.creator?.is_system
              ? observationDetails?.creator?.name
              : (observationDetails?.creator?.name | titlecase) +
                ' | ' +
                (observationDetails?.creator?.status | transloco)
          }}
        </div>
        <div
          *ngIf="
            observationDetails.unique_id === 'WH-8170' ||
            observationDetails.unique_id === 'WH-9810' ||
            observationDetails.unique_id === 'WH-5271'
          "
        >
          {{ 'WhiteHelmet AI' | transloco }}
        </div>
        <label>{{ 'Code' | transloco }}: </label>
        <div>
          {{ observationDetails?.code_info }}
        </div>
        <label>{{ 'Code' | transloco }}: </label>
        <div>
          {{ observationDetails?.code_info }}
        </div>
      </div>

      <div *ngIf="observationDetails?.type !== 'note'" class="py-3 border-t">
        <div *ngIf="!changeStatus" class="flex flex-row justify-between items-center">
          <div>
            <label>{{ 'status' | transloco }}: </label>
            <div class="flex flex-row items-center gap-2">
              {{ validatedStatus?.replace('_', ' ') | transloco }}
              <mat-icon
                *ngIf="isClosedAndLocked"
                svgIcon="heroicons_solid:lock-closed"
                class="text-gray-400 w-4 h-4"
                [matTooltip]="'OBSERVATION_LOCKED_CLOSED' | transloco"
              >
              </mat-icon>
            </div>
            <label>{{ 'Due Date' | transloco }}: </label>
            <div [innerHTML]="observationDetails?.due_date | dateTransform | titlecase"></div>
          </div>
        </div>
        <!--For print point location-->
        <div class="flex flex-col pt-2 pb-3">
          <label class="flex flex-row mb-2 color"
            >{{ observationDetails.floor?.floor_name | titlecase }}:
          </label>
          <div style="position: relative">
            <img
              [src]="observationDetails.floor?.floor_image"
              class="rounded-md overflow-hidden"
              style="max-width: 100%; max-height: 100%"
              (load)="adjustDotPosition($event)"
            />
            <div
              *ngIf="observationDetails.observation_flag === 'observation_on_floor_plan'"
              class="dot"
              style="position: absolute"
              [style.left]="(observationDetails.location_x / imageNaturalWidth) * 100 + '%'"
              [style.top]="(observationDetails.location_y / imageNaturalHeight) * 100 + '%'"
            >
              <div
                style="
                  background-color: yellow;
                  border: 1px solid black;
                  width: 10px;
                  height: 10px;
                  border-radius: 50%;
                "
              ></div>
            </div>
            <div
              *ngIf="observationDetails.observation_flag === 'observation_on_360'"
              class="dot"
              style="position: absolute"
              [style.left]="(observationDetails.point.point_x / imageNaturalWidth) * 100 + '%'"
              [style.top]="(observationDetails.point.point_y / imageNaturalHeight) * 100 + '%'"
            >
              <div
                style="
                  background-color: yellow;
                  border: 1px solid black;
                  width: 10px;
                  height: 10px;
                  border-radius: 50%;
                "
              ></div>
            </div>
            <div
              *ngIf="observationDetails.observation_flag === 'observation_on_360'"
              class="dot"
              style="position: absolute"
              [style.left]="(observationDetails.point.point_x / imageNaturalWidth) * 100 + '%'"
              [style.top]="(observationDetails.point.point_y / imageNaturalHeight) * 100 + '%'"
            >
              <div
                style="
                  background-color: yellow;
                  border: 1px solid black;
                  width: 10px;
                  height: 10px;
                  border-radius: 50%;
                "
              ></div>
            </div>
          </div>
        </div>

        <div class="flex flex-row items-center" *ngIf="changeStatus">
          <mat-form-field
            [class]="'w-full me-3 ' + (isArabic() ? 'text-left' : 'text-right')"
            appearance="fill"
            [dir]="isArabic() ? 'rtl' : 'ltr'"
          >
            <mat-label>{{ 'status' | transloco }}</mat-label>
            <mat-select #statusVal [value]="validatedStatus">
              <mat-option
                *ngFor="let status of observationStatus"
                [value]="status.value"
                [disabled]="status.disabled"
              >
                {{ status?.name | transloco }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <button (click)="changeStatus = false; stopEditing()">
            <mat-icon svgIcon="close" class="icon-size-3" (click)="stopEditing()"></mat-icon>
          </button>

          <button>
            <mat-icon
              color="primary"
              class="icon-3"
              svgIcon="check"
              (click)="editObservationStatus(statusVal.value); stopEditing()"
            >
            </mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="border rounded gap-2 p-6 my-8 break-before-page print-area">
    <div class="flex flex-row justify-start" style="min-height: 60px">
      <div class="border rounded p-2 m-2 w-1/2">
        <label>{{ 'categories' | transloco }}:</label>
        <div>
          <span *ngIf="observationDetails?.categories_str" class="pill text-white">
            {{ observationDetails?.categories_str?.split(',')[0] }}
          </span>
        </div>
        <!-- Sub-categories in print view -->
        <div *ngIf="observationDetails?.sub_categories?.length" class="mt-2">
          <label class="text-sm">{{ 'sub-categories' | transloco }}:</label>
          <div>
            <span
              *ngFor="let subCategory of observationDetails?.sub_categories"
              class="pill text-white text-sm"
            >
              {{ getCategoryDisplayName(subCategory) }}
            </span>
          </div>
        </div>
      </div>

      <div class="border rounded p-2 m-2 w-1/2">
        <label>{{ 'Assignees' | transloco }}:</label>
        <div>
          <div
            style="display: inline-block"
            *ngFor="let member of observationDetails?.user_assignees_str?.split(',')"
            class="pill text-white"
          >
            {{ member }}
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-row justify-start" style="min-height: 60px">
      <div class="border rounded p-2 m-2 w-1/2">
        <label>{{ 'description' | transloco }}:</label>
        <div class="break-words">
          <p
            [innerHTML]="observationDetails?.description"
            [ngClass]="translateService.getActiveLang() === 'ar' ? 'isRTL' : 'isLTR'"
            class="ql-editor"
          ></p>
        </div>
      </div>
      <div class="border rounded p-2 m-2 w-1/2">
        <label>{{ 'attachments' | transloco }}:</label>
        <div
          *ngIf="observationDetails?.attached_files?.length > 0"
          class="w-full p-2 mb-2 darker-bg rounded-md flex flex-wrap justify-start gap-2"
        >
          <div
            *ngIf="observationDetails?.attached_files?.length > 0"
            class="w-full p-2 mb-2 darker-bg rounded-md flex flex-wrap justify-start"
          >
            <div
              *ngFor="let attache of observationDetails?.attached_files"
              class="relative hover:opacity-70 transition-all bg-accent-800 flex justify-center rounded-md"
              style="min-width: 4.5rem"
            >
              <ng-container [ngSwitch]="attache.extension.toLowerCase()">
                <!-- Image Extensions (jpg, jpeg, png, gif) -->
                <ng-container *ngSwitchCase="'jpg'">
                  <img
                    [src]="attache?.path"
                    alt="attache.file_name"
                    class="h-15 w-auto rounded-md"
                  />
                </ng-container>
                <ng-container *ngSwitchCase="'jpeg'">
                  <img
                    [src]="attache?.path"
                    alt="attache.file_name"
                    class="h-15 w-auto rounded-md"
                  />
                </ng-container>
                <ng-container *ngSwitchCase="'png'">
                  <img
                    [src]="attache?.path"
                    alt="attache.file_name"
                    class="h-15 w-auto rounded-md"
                  />
                </ng-container>
                <ng-container *ngSwitchCase="'gif'">
                  <img
                    [src]="attache?.path"
                    alt="attache.file_name"
                    class="h-15 w-auto rounded-md"
                  />
                </ng-container>

                <!-- PDF Extension -->
                <ng-container *ngSwitchCase="'pdf'">
                  <img
                    [src]="'/assets/images/file_pdf.png'"
                    alt="attache.file_name"
                    class="h-15 w-auto rounded-md"
                  />
                </ng-container>

                <!-- MP4 Extension -->
                <div *ngSwitchCase="'mp4'" class="rounded-lg bg-accent-700 p-4 overflow-hidden">
                  <mat-icon class="icon-size-6" svgIcon="ondemand_video"></mat-icon>
                </div>

                <!-- Default for Unhandled Extensions -->
                <div *ngSwitchDefault class="rounded-lg bg-accent-700 p-4 overflow-hidden">
                  <mat-icon class="icon-size-6" svgIcon="document_scanner"></mat-icon>
                </div>
              </ng-container>

              <!-- Download Icon -->
              <mat-icon
                class="absolute top-1 right-1 text-white"
                svgIcon="mat_solid:download"
                (click)="downloadFile(attache)"
              >
              </mat-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-row justify-start" style="min-height: 60px">
      <div class="border rounded p-2 m-2 w-1/2">
        <label>{{ 'recommended corrective action' | transloco }}:</label>
        <div class="break-words max-w-full">
          <p
            [innerHTML]="observationDetails?.recommended_corrective_action"
            [ngClass]="translateService.getActiveLang() === 'ar' ? 'isRTL' : 'isLTR'"
            class="ql-editor"
            style="overflow-wrap: anywhere"
          ></p>
        </div>
      </div>

      <div class="border rounded p-2 m-2 w-1/2">
        <label>{{ 'Close-Out Evidence' | transloco }}:</label>
        <div
          *ngIf="observationDetails?.evidence_file"
          class="w-full p-2 mb-2 darker-bg rounded-md flex flex-wrap justify-start gap-2"
        >
          <div class="w-full p-2 mb-2 darker-bg rounded-md flex flex-wrap justify-start">
            <div
              class="relative hover:opacity-70 transition-all bg-accent-800 flex justify-center rounded-md"
              style="min-width: 4.5rem"
            >
              <ng-container [ngSwitch]="observationDetails?.evidence_file_type">
                <!-- Image Extensions (jpg, jpeg, png, gif) -->
                <ng-container *ngSwitchCase="'image'">
                  <img
                    [src]="observationDetails?.evidence_file"
                    alt="attache.file_name"
                    class="h-15 w-auto rounded-md"
                  />
                </ng-container>
                <ng-container *ngSwitchCase="'gif'">
                  <img
                    [src]="observationDetails?.evidence_file"
                    alt="attache.file_name"
                    class="h-15 w-auto rounded-md"
                  />
                </ng-container>

                <!-- PDF Extension -->
                <ng-container *ngSwitchCase="'pdf'">
                  <img
                    [src]="'/assets/images/file_pdf.png'"
                    alt="attache.file_name"
                    class="h-15 w-auto rounded-md"
                  />
                </ng-container>

                <!-- MP4 Extension -->
                <div *ngSwitchCase="'video'" class="rounded-lg bg-accent-700 p-4 overflow-hidden">
                  <mat-icon class="icon-size-6" svgIcon="ondemand_video"></mat-icon>
                </div>

                <!-- Default for Unhandled Extensions -->
                <div *ngSwitchDefault class="rounded-lg bg-accent-700 p-4 overflow-hidden">
                  <mat-icon class="icon-size-6" svgIcon="document_scanner"></mat-icon>
                </div>
              </ng-container>

              <!-- Download Icon -->
              <mat-icon
                class="absolute top-1 right-1 text-white"
                svgIcon="mat_solid:download"
                (click)="downloadFile(attache)"
              >
              </mat-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
